import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ArrowUpRight } from 'lucide-react';

const ServiceHero = ({ overline, staticTitle, typingWords, description, buttonText, className }) => {
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const heroImages = [
    "/img/service/service-banner.png",
    "/img/service/service-banner.png"
  ];

  const defaultWords = [
    "Construction Projects",
    "Architecture Projects",
    "Engineering Projects"
  ];

  const wordsToType = typingWords || defaultWords;

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentHeroSlide((prev) => (prev + 1) % heroImages.length);
    }, 4000); // changes every 4 seconds
    return () => clearInterval(slideInterval);
  }, [heroImages.length]);

  useEffect(() => {
    if (!wordsToType || wordsToType.length === 0) return;

    const currentWord = wordsToType[typingIndex];
    if (!currentWord) return;

    let typingSpeed = isDeleting ? 50 : 120; // Deleting is faster than typing

    if (!isDeleting && charIndex === currentWord.length) {
      typingSpeed = 1500;
      setTimeout(() => setIsDeleting(true), typingSpeed);
      return;
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setTypingIndex((prev) => (prev + 1) % wordsToType.length);
      return;
    }

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setTypedText(currentWord.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      } else {
        setTypedText(currentWord.substring(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, typingIndex, wordsToType]);

  return (
    <section className={`service-hero ${className || ''}`}>
      <div className="hero-content">
        <p className="hero-subtitle">
          {overline || "BIM MODELING SERVICES USA"}
        </p>

        <h1>
          {staticTitle || (
            <><span className="text-primary">Professional BIM Modeling</span> Services for</>
          )}
          {wordsToType && wordsToType.length > 0 && (
            <>
              <br />
              <span style={{
                color: '#ffffff',
                display: 'inline-block',
                minHeight: '1.3em',
                verticalAlign: 'bottom'
              }}>
                {typedText || "\u00A0"}
              </span>
            </>
          )}
        </h1>

        {description ? (
          <p className="service-description">{description}</p>
        ) : (
          <>
            <p className="service-description">
              We provide a comprehensive list of Outsourcing BIM modeling services to clients across the world, covering different aspects of construction such as architecture, structure, MEP, and other mechanical aspects.
            </p>
            <p className="service-description">We are a specialized provider of BIM modeling services based in the USA, offering custom 3D, 4D, and 5D BIM services to professionals in the AEC industry, including architects, contractors, engineers, surveyors, designers, and consultants, as well as engineering design firms. We have highly trained Revit professionals who have worked on more than 500 construction projects, leveraging their in-depth industry knowledge to offer reliable BIM solutions.</p>
          </>
        )}

        <button className="hero-btn">
          {buttonText || "Hire react developers now"} <ArrowUpRight size={20} />
        </button>
      </div>
    </section>
  );
};

export default ServiceHero;
